<script>
	// @ts-nocheck

	import Grid from 'svelte-grid';
	import GridItem from '../components/GridItem.svelte';
	import CreateItemDialog from '../components/dialogs/builder/CreateItemDialog.svelte';
	import AddCustomProducts from '../components/dialogs/builder/AddCustomProducts.svelte';
	import PreviewGridDialog from '../components/dialogs/builder/PreviewGridDialog.svelte';
	import StyleOptions from '../components/StyleOptions.svelte';
	import { generateItems, items, handleSubmitAction, gridPageType } from '../utils/utils.js';
	import { onMount, createEventDispatcher } from 'svelte';
	import { getGrid, saveGridConfig } from '../utils/api.js';
	import { Icon, CodeEditor } from '@shopboxai/sb-portal-components';
	import DeviceSwitcher from '../components/DeviceSwitcher.svelte';

	export let data;
	let grid = {
		name: '',
		custom_css: '// add css here',
		mobile: { items: [] },
		desktop: { items: [] },
		style_options: null,
		custom_products: []
	};

	let defaultStyleOptions = {
		heading: {
			size: '',
			family: '',
			weight: '',
			color: null
		},
		text: {
			size: '',
			family: '',
			weight: '',
			color: null,
			align: ''
		},
		price: {
			size: '',
			family: '',
			weight: '',
			color: '',
			align: '',
			saleColor: null,
			saleFontWeight: '',
			saleOrder: 1
		},
		general: {
			hideBorders: false,
			brandEnabled: false,
			centerCarouselTitle: false,
			carouselControlsMinimal: false,
			backgroundColor: null,
			itemBorderRadius: '',
			productCardBackgroundColor: null,
			saleBannerColor: null,
			newBannerColor: null
		},
		imageStyles: {
			aspectRatio: '',
			maxHeight: '',
			coverMethod: ''
		},
		seeMore: {
			text: '',
			size: '',
			family: '',
			weight: '',
			color: null,
			textDecoration: ''
		},
		addToCart: {
			enabled: false,
			text: '',
			size: '',
			family: '',
			weight: '',
			color: null,
			textDecoration: '',
			margin: '',
			padding: '',
			variantsText: '',
			text: ''
		},
		findSimilar: {
			enabled: false,
			size: '',
			family: '',
			weight: '',
			color: null,
			textDecoration: '',
			margin: '',
			padding: '',
			background: null
		}
	};
	$: gridCssText = grid.custom_css;
	const cols = [[1000, 4]];
	let rowHeight = 265;
	let isMobileView = false;

	const dispatch = createEventDispatcher();
	const back = () => {
		dispatch('back');
	};
	const deleteItem = (e) => {
		console.log(e.detail);
		handleSubmitAction(e.detail);
	};
	const submitDialog = async (e) => {
		console.log(e.detail);
		if (e.detail.includeOnMobile) {
			handleSubmitAction({ ...e.detail, device: 'mobile', size: 4 });
		}
		if (e.detail.includeOnDesktop) {
			handleSubmitAction({ ...e.detail, device: 'desktop' });
		}
		if (e.detail.edit == true) {
			handleSubmitAction(e.detail);
		}
	};
	const submitConfig = async (e) => {
		await saveGridConfig(
			data.id,
			grid.name,
			grid.custom_css,
			false,
			grid.style_options,
			grid.custom_products
		);
		back();
	};

	let mounted = false;
	onMount(async () => {
		grid = await getGrid(data.id);

		$gridPageType = grid.page_type ? grid.page_type : null;

		let devices = ['mobile', 'desktop'];
		let itemData = {};

		if (!grid.custom_css) {
			grid.custom_css = '';
		}

		if (!grid.custom_products) {
			grid.custom_products = [];
		}

		if (!grid.style_options) grid.style_options = defaultStyleOptions;

		grid.style_options = Object.assign({}, defaultStyleOptions, grid.style_options);

		if (!grid.style_options?.general?.backgroundColor)
			grid.style_options.general.backgroundColor = null;
		if (!grid.style_options?.general?.newBannerColor)
			grid.style_options.general.newBannerColor = null;
		if (!grid.style_options?.general?.saleBannerColor)
			grid.style_options.general.saleBannerColor = null;
		if (!grid.style_options?.general?.productCardBackgroundColor)
			grid.style_options.general.productCardBackgroundColor = null;

		devices.forEach((device) => {
			itemData[device] = grid[device].items;
			itemData[device].map((item) => {
				if (device == 'mobile') item.size = 4;
				item.device = device;
			});
		});
		generateItems(itemData);
		mounted = true;
	});
</script>

<header>
	<h1>
		<button on:click={back}
			><svg
				width="10"
				height="18"
				viewBox="0 0 10 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M9 17L1 9L9 1"
					stroke="#091EB5"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</button>
		{grid.name} <sup>{$gridPageType}</sup>
	</h1>
	<div>
		<AddCustomProducts bind:data={grid.custom_products} on:submit={submitDialog} />
		<CreateItemDialog on:submit={submitDialog} customProducts={grid.custom_products} />
		<PreviewGridDialog
			on:submit={submitConfig}
			data={{
				id: grid.id,
				currency: data.currency,
				name: grid.name,
				css: grid.custom_css,
				styleOptions: grid.style_options,
				customProducts: grid.custom_products
			}}
		/>
	</div>
</header>

<div class="buider-wrapper">
	<div class="demo-wrapper " style="--rowHeight:{rowHeight}px">
		{#if mounted}
			<DeviceSwitcher bind:isMobileView />
			<div class="sb-desktop demo-container " class:hidden={isMobileView}>
				<!-- <span><Icon name="desktop" />Desktop </span> -->
				<Grid bind:items={$items.desktop} {rowHeight} let:item let:dataItem fastStart={true} {cols}>
					<GridItem
						on:delete={deleteItem}
						on:edit={submitDialog}
						customProducts={grid.custom_products}
						{item}
						{dataItem}
					/>
				</Grid>
			</div>
			<div class="sb-mobile demo-container  " class:hidden={!isMobileView}>
				<!-- <span><Icon name="mobile" /> Mobile</span> -->
				<Grid bind:items={$items.mobile} {rowHeight} let:item let:dataItem fastStart={true} {cols}>
					<GridItem
						on:delete={deleteItem}
						on:edit={submitDialog}
						customProducts={grid.custom_products}
						{dataItem}
						mobile={true}
					/>
				</Grid>
			</div>
		{/if}
		<br />
		<CodeEditor
			description={'Enter any custom styles here.'}
			bind:origin={grid}
			bind:value={gridCssText}
			syntax="css"
			nestedKeys="custom_css"
		/>

		<p class="docs-link">
			For more information see our <a
				href="https://docs.shopbox.ai/docs/shopbox-grid/implementation#_2-2-customizing-the-grid-using-css-variables"
				target="_blank">docs</a
			>.
		</p>
	</div>

	<StyleOptions bind:options={grid.style_options} platform={data.platform} />
</div>

<style>
	header {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1em 0;
		z-index: 2;
		background-color: #fff;
		border-bottom: none !important;
		position: sticky;
		top: 40px;
	}
	sup {
		font-size: 0.6em;
		font-weight: normal;
	}
	.demo-wrapper {
		width: 100%;
		margin-bottom: 2em;
		min-height: calc(var(--rowHeight) * 2);
		overflow: hidden;
		border-radius: 2px;
		position: sticky;
		top: 115px;
	}

	.demo-container {
		padding: 1em 0.5em 0.5em;
		border-radius: 2px;
	}
	.demo-container :global(header) {
		border-bottom: none !important;
		padding: unset;
	}
	.demo-container :global(header p) {
		font-size: 1rem !important;
	}
	.sb-desktop {
		background-color: var(--bg-c);
	}
	.sb-mobile {
		width: 310px;
		background-color: var(--bg-c);
	}
	.hidden {
		display: none;
	}
	.demo-container span {
		display: flex;
		align-items: center;
		color: var(--t-c-l);
	}
	.demo-container :global(span svg) {
		margin-right: 5px;
	}
	:global(.device-selectors .checkbox-wrapper) {
		margin-bottom: 0 !important;
		margin-top: 8px;
	}
	:global(.device-selectors .checkbox-wrapper input) {
		margin-bottom: 0px !important;
		padding: 4px !important;
	}
	:not(.sb-mobile) :global(.svlt-grid-container) {
		/* max-height: calc(var(--rowHeight) * 3); */
	}
	.docs-link {
		font-size: 12px;
		color: var(--t-c-l);
	}
	.docs-link a {
		color: var(-t-c);
		text-decoration: underline !important;
	}

	/* redesign */
	.buider-wrapper {
		display: grid;
		grid-template-columns: 3fr 1fr;
		gap: 1em;
		align-items: flex-start;
	}
</style>
